import { validateEmail } from '../../Shared/validations';

const validate = values => {
    const errors = {
        ...validateEmail(values)
    };

    return errors;
};

export default validate;
